import React from "react";
import TagCard from "./TagCard";
import { Row, Col } from 'react-bootstrap';
import { TagCategoryRule } from "src/docuclipper/DocuclipperTypes";

type Props = {
  tags: Array<{
    id: string;
    tag: string;
    regexes: string;
    jsonRules: TagCategoryRule
  }>;
  onDeleteTag: (id: string) => void;
  onAddKeyword: (tagId: string, keyword: string, isPositive: boolean) => void;
  onRemoveKeyword: (tagId: string, keyword: string, isPositive: boolean) => void;
};

export const TagCards: React.FC<Props> = ({
  tags,
  onDeleteTag,
  onAddKeyword,
  onRemoveKeyword,
}) => {
  const rows = Math.ceil(tags.length / 5);

  const parseKeywords = (jsonRules, regexes) => {
    try {
      if (jsonRules) {
        const rules = JSON.parse(jsonRules);
        const positiveKeywords = rules.conditions.all.find(condition => condition.operator === 'containsAny')?.value.keywords || [];
        const negativeKeywords = rules.conditions.all.find(condition => condition.operator === 'doesNotContainAny')?.value.keywords || [];
        return { positive: positiveKeywords, negative: negativeKeywords };
      } else {
        const parsedRegexes = regexes ? JSON.parse(regexes) : [];
        return { positive: parsedRegexes, negative: [] };
      }
    } catch (error) {
      console.error("Error parsing jsonRules or regexes:", error);
      return { positive: [], negative: [] };
    }
  };

  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <Row key={rowIndex}>
          {tags
            .slice(rowIndex * 6, (rowIndex + 1) * 6)
            .map((tag) => (
              <Col key={tag.id} md={2}>
                <TagCard
                  tag={tag.tag}
                  onDeleteTag={() => onDeleteTag(tag.id)}
                  onRemoveKeyword={(keyword, isPositive) => onRemoveKeyword(tag.id, keyword, isPositive)}
                  onAddKeyword={(keyword, isPositive) => onAddKeyword(tag.id, keyword, isPositive)}
                  keywords={parseKeywords(tag.jsonRules, tag.regexes)}
                />
              </Col>
          ))}
        </Row>
      ))}
    </>
  );
};

export default TagCards;
